//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { required, minLength } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";
import ImportAppConditions from "@/components/Diagrams/ImportConditions/ImportAppConditions.vue";
import variablesCard from "@/components/Diagrams/variables-card.vue";
import {
    normalize, getStatement, deepCopy, evBus
} from "./set-conditions";
import NestedDraggable from "./subcomponents/NestedDragable.vue";

export default {
    components: {
        ImportAppConditions,
        variablesCard,
        NestedDraggable,
        AQButton,
        AQCard
    },
    props: {
        value: {
            required: true,
            type: Object,
            default() {
                return {};
            }
        },
        readonly: {
            required: false,
            type: Boolean,
            default: false
        },
        basePath: {
            type: String,
            default: ""
        },
        fromBlock: { type: Boolean, default: false },
        disableAddCondBtn: { type: Boolean, default: false },
        canImport: { type: Boolean, default: true },
        fromRepeatable: { type: Boolean, default: false },
        blackList: { type: Object, default: () => ({}) }, // blackList for picker
        selectedFields: {
            required: false,
            type: Array,
            default() {
                return [];
            }
        }
    },
    validations: {
        conditions: {
            required,
            minLength: minLength(1),
            $each: {
                val1: {
                    required(value, obj) {
                        // validation is required only for type condition
                        if (obj.type === "condition") {
                            return value && value.value;
                        }
                        // else return valid
                        return true;
                    }
                },
                val2: {
                    required(value, obj) {
                        // validation is required only for type condition
                        if (obj.type === "condition") {
                            return value && value.value;
                        }
                        // else return valid
                        return true;
                    }
                }
            }
        }
    },
    data() {
        return {
            initialConditions: {},
            openImportConditions: false,
            statement: "",
            showVariablesCard: false,
            defaultVariablesCardTab: "",
            selectedConditionValue: null,
            basePathCustom: "",
            item: {
                conditions: [],
                type: "group",
                logicOperatorAfter: null
            },
            logicOperators: {
                "&&": "and",
                "||": "or"
            }
        };
    },
    computed: {
        ...mapGetters("diagrams", ["selectedPluginConfigData"]),
        computedItem() {
            return [...this.item.conditions];
        },
        mode() {
            let modeToReturn;
            if (
                this.selectedPluginConfigData.pluginType
                    === "EXPOSE_API_PLUGIN"
                || this.selectedPluginConfigData.pluginType
                    === "EXTERNAL_SOURCE_PLUGIN"
            ) {
                modeToReturn = "f2";
            } else {
                modeToReturn = this.selectedFields && this.selectedFields.length
                    ? "h"
                    : "c";
            }
            return modeToReturn;
        }
    },

    watch: {
        value: {
            handler(newVal) {
                this.statement = newVal && newVal.statement ? newVal.statement : "";
                this.item.conditions = newVal && newVal.conditions ? newVal.conditions : [];
                if (this.showVariablesCard) {
                    this.onHideSpecialIdentificators();
                }
            },
            deep: true,
            immediate: true
        },
        computedItem: {
            handler(newVal) {
                this.statement = getStatement(newVal);
            },
            deep: true
        },
        statement: {
            handler(newVal, oldVal) {
                if (newVal !== oldVal) {
                    this.$emit("input", {
                        statement: this.statement,
                        conditions: normalize(this.item.conditions)
                    });
                }
            }
        },
        showVariablesCard: {
            handler(newValue) {
                this.$emit("dataModelVisibility", newValue);
                if (this.fromBlock) {
                    this.$emit("extendParent", newValue);
                }
            }
        }
    },

    created() {
        this.initialConditions = deepCopy(this.value).clone;
    },
    mounted() {
        evBus.$on("refresh", this.refresh);
    },

    methods: {
        openImportModal() {
            this.openImportConditions = true;
        },
        importSelectedRule(rule) {
            rule.conditions.conditions.forEach(condition => {
                this.item.conditions.push(condition);
            });
        },
        refresh() {
            this.item.conditions = normalize(this.item.conditions);
        },
        addNewCondition() {
            if (!this.disableAddCondBtn) {
                const newCondition = {
                    type: "condition",
                    logicalCondition: "==",
                    val1: {
                        type: "MOD",
                        value: "",
                        fieldType: ""
                    },
                    val2: {
                        type: "MOD",
                        value: "",
                        fieldType: ""
                    },
                    logicOperatorAfter: null
                };
                this.item.conditions.push(newCondition);
            }
        },
        addNewGroup() {
            if (!this.disableAddCondBtn) {
                const newGroup = {
                    type: "group",
                    logicOperatorAfter: null,
                    conditions: []
                };
                this.item.conditions.push(newGroup);
            }
        },
        onShowDataModel({ condition, field }) {
            this.selectedConditionValue = { condition, field };
            this.defaultVariablesCardTab = "dataModel";
            this.showVariablesCard = true;
            this.basePathCustom = field === "val1" ? this.basePath : "";
        },
        onShowVariables({ condition, field }) {
            this.selectedConditionValue = { condition, field };
            this.defaultVariablesCardTab = "variables";
            this.showVariablesCard = true;
        },
        onHideSpecialIdentificators() {
            this.showVariablesCard = false;
        },
        onFieldClicked(data) {
            this.selectedConditionValue.condition[this.selectedConditionValue.field].value = data.field.name;
            this.selectedConditionValue.condition[this.selectedConditionValue.field].fieldType = data.field.type;
            this.onHideSpecialIdentificators();
        },
        onTabChange() {
            this.selectedConditionValue.condition[this.selectedConditionValue.field].type = "MOD";
            // var type = "VAR";

            // if (data === "dataModel") {
            //     type = "MOD";
            // }

            // this.selectedConditionValue.condition[
            //     this.selectedConditionValue.field
            // ].type = type;
        }
    }
};
